import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';

export const ScrollableBox = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
    ({ style, ...props }, ref) => (
        <div
            ref={ref}
            style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                maxHeight: '270px',
                ...style,
            }}
            {...props}
        />
    )
);
